import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import FaqRoute from "./faq";

// Conduct is effectively a faq alias
export default class ConductRoute extends FaqRoute {
  constructor() {
    super(...arguments);
    _defineProperty(this, "pageId", "conduct");
  }
}